var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"title is-3"},[_vm._v("Products & Services")]),_c('hr'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }